import { DOCUMENT } from '@angular/common';
import { inject } from '@angular/core';
import { type NavigationError, Router } from '@angular/router';
import { isChunkLoadError } from './chunk-reload.utils';

export function handleNavigationError(
  error: NavigationError,
  notFoundRoute: string,
): void {
  const document = inject(DOCUMENT);
  if (isChunkLoadError(error.error)) {
    const reloadKey = `chunk-reload:${error.url}`;
    if (!sessionStorage.getItem(reloadKey)) {
      sessionStorage.setItem(reloadKey, '1');
      document.location.assign(error.url);
    }
    return;
  }
  // A resolver/matcher threw (e.g. invalid UUID): redirect instead of silently
  // cancelling, passing the failed URL as replaceUrl so it stays in the address bar.
  inject(Router).navigate([notFoundRoute, error.url]);
}
